import { render, staticRenderFns } from "./auth-icon.vue?vue&type=template&id=383081d2&scoped=true"
import script from "./auth-icon.vue?vue&type=script&lang=js"
export * from "./auth-icon.vue?vue&type=script&lang=js"
import style0 from "./auth-icon.vue?vue&type=style&index=0&id=383081d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383081d2",
  null
  
)

export default component.exports